import { connect } from 'react-redux';
import FliteviewSettingsView from './FliteviewSettingsView.jsx';
import { LIST_VIEWER } from '../../../constants/collectionConstants.jsx';


import _ from "lodash";
import hasAccess from '../../../services/hasAccess.jsx';
import { updateAccount } from 'src/redux/actions/accounts.ts';

const mapStateToProps = (state, ownProps) => {
  return {
    account: state.accounts.item,
    updating: state.accounts.updating,
    updated: state.accounts.updated,
    error: state.accounts.error,
    librarySettings: _.get(state, "accounts.item.librarySettings"),
    assetViewer: _.get(state, "accounts.item.librarySettings.assetViewer")
    
    || 
    
    LIST_VIEWER


  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateAccount: (account) => {      
      return dispatch(updateAccount(account));
    }
  }
}

const FliteviewSettingsPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(FliteviewSettingsView);

export default hasAccess(FliteviewSettingsPage, 'viewer-settings');